var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcChevronLeftWhite = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "13B7FD78-5DC2-4079-96A4-2E207546601E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02.-eKYC-Updated---Out-2021",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01.01.03-Validation:-Position-face",
    transform: "translate(-24.000000, -24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u26A1\\uFE0F",
    transform: "translate(0.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow_left",
    transform: "translate(24.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "bg",
    fillOpacity: 0,
    fill: "#D8D8D8",
    transform: "translate(12.000000, 12.000000) rotate(90.000000) translate(-12.000000, -12.000000) ",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "11 3.5 2.5 12 11 20.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 12,
    x2: 21.5,
    y2: 12,
    id: "Shape",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcChevronLeftWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_chevron_left_white.422c496b13ae3a9441fcc7f19f7a6565.svg";